import { z } from 'zod'

/* Admin Companies API */

/**
 * Response item for a single company returned by admin company API.
 */
export interface AdminCompanyResponse {
  id: string
  name: string
  type: string
  vatId: string
  streetAddress: string
  postalCode: string
  town: string
}

/**
 * Schema for 'AdminCompanyResponseDto' (backend API data type).
 */
export const AdminCompanyResponseSchema = z.object({
  id: z.string(),
  name: z.string(),
  type: z.string(),
  vatId: z.string(),
  streetAddress: z.string(),
  postalCode: z.string(),
  town: z.string()
})

/**
 * Schema for 'AdminCompanyResponseDto' list response.
 */
export const AdminCompaniesResponseSchema = z.array(AdminCompanyResponseSchema)

/**
 * Company integration types.
 */
export enum CompanyIntegrationType {
  Generic = 'Generic',
  InPulse = 'InPulse',
  Vesikanta = 'Vesikanta',
  Aqua = 'Aqua'
}

/**
 * Response for 'CompanyIntegrationResponseDto' (backend API data type).
 */
export interface AdminCompanyIntegrationResponse {
  companyId: string
  enabled: boolean
  integrationType: CompanyIntegrationType
  cronString: string
  url: string
  username?: string
  inPulseFormat?: string
  tietoIdentifier?: string
}

/**
 * Schema for 'CompanyIntegrationResponseDto' (backend API data type).
 */
export const AdminCompanyIntegrationResponseSchema = z.object({
  companyId: z.string(),
  enabled: z.boolean(),
  integrationType: z.nativeEnum(CompanyIntegrationType),
  cronString: z.string(),
  url: z.string(),
  username: z.string().nullish().transform(it => it ?? undefined),
  inPulseFormat: z.string().nullish().transform(it => it ?? undefined),
  tietoIdentifier: z.string().nullish().transform(it => it ?? undefined)
})

/**
 * Response for 'CompanyUserResponseDto' (backend API data type).
 */
export interface AdminCompanyUserResponse {
  id: string
  companyId: string
  username: string
  systemAdmin: boolean
}

/**
 * Schema for 'CompanyUserResponseDto' (backend API data type).
 */
export const AdminCompanyUserResponseSchema = z.object({
  id: z.string(),
  companyId: z.string(),
  username: z.string(),
  systemAdmin: z.boolean()
})

/**
 * Schema for 'CompanyUserResponseDto' list response.
 */
export const AdminCompanyUsersResponseSchema = z.array(AdminCompanyUserResponseSchema)

/**
 * Response for 'UnassignedUserResponseDto' (backend API data type).
 */
export interface UnassignedUserResponseItem {
  id: string
  username: string
}

/**
 * Schema for 'UnassignedUserResponseDto' (backend API data type).
 */
export const UnassignedUserResponseItemSchema = z.object({
  id: z.string(),
  username: z.string()
})

/**
 * Schema for 'UnassignedUserResponseDto' list.
 */
export const UnassignedUserResponseItemsResponseSchema = z.array(UnassignedUserResponseItemSchema)
